module.exports = __webpack_public_path__ + "static/media/icon_delete2_warning.49e087fb.svg";